
import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'

export interface Tag {
  id: string
  uid: string
  path: string
  package_id: string
  created_at: string
  updated_at: string
  package?: {
    id: string
    name: string
    company_id: string
    created_at: string
    updated_at: string | null
  }
}

interface TagsResponse {
  data: Tag[]
  total: number
  limit: number
  offset: number
}

type UseTagsParams = {
  limit?: number
  offset?: number
}

type UseTagsResult = {
  data: TagsResponse | null
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
}

export const useTags = (params: UseTagsParams = {}, options?: { enabled?: boolean }): UseTagsResult => {
  const stableParams = {
    limit: params.limit ?? 100,
    offset: params.offset ?? 0,
  }

  const query = useQuery({
    queryKey: ['tags', 'available', stableParams],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: '/tags/admin/available',
        params: stableParams,
      })
      return response.data as TagsResponse
    },
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
    gcTime: 1000 * 60 * 10, // 10 minutes garbage collection
  })

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}
